// extracted by mini-css-extract-plugin
module.exports = {"root":"InboxNav_root__2UEUa","tab":"InboxNav_tab__tnDMD"};